import React from 'react';
import { Breadcrumb, Button, Col, Row, Space } from 'antd';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { GUTTER } from '../../views/vendorlink-views/components/Gutter';

export interface BreadcrumbItem {
  name: string;
  link: string;
}

interface PageHeaderProps {
  display?: boolean;
  breadcrumbs?: BreadcrumbItem[];
  action?: React.ReactNode;
}

export const PageHeader = ({ display, breadcrumbs, action }: PageHeaderProps) => {
  const breadcrumbElement = breadcrumbs && (
    <Breadcrumb separator={<span className="heading-s text-content-secondary">/</span>}>
      {breadcrumbs.map((b, i, arr) => (
        <Breadcrumb.Item key={i}>
          <Link to={b.link} className={classNames('heading-s', i !== arr.length - 1 && 'text-content-secondary link')}>
            {b.name}
          </Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );

  return display ? (
    <Row gutter={GUTTER} justify="space-between">
      <Col>
        <div className="app-page-header">{breadcrumbElement}</div>
      </Col>
      <Col>{action}</Col>
    </Row>
  ) : null;
};

export default PageHeader;
